<template>
  <span
    v-if="label !== ''"
    :class="['zg-btn', 'p-lr5', 'zg-btn-' + type, disable || loading ? 'disable' : '']"
    @click="onClickBtn"
  >
    <i v-show="loading" class="el-icon-loading"></i>
    <span>{{ label }}</span>
    <el-tooltip effect="dark" :content="tips" placement="right-start" v-if="tips">
      <i class="el-icon-warning-outline"></i>
    </el-tooltip>
  </span>
</template>
<script>
export default {
  name: 'ZgBtn',
  props: {
    label: {
      type: String,
      default: '',
      required: true
    },
    // default plain base
    type: {
      type: String,
      default: 'text'
    },
    disable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    onClickBtn() {
      if (this.disable) return
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../src/common/styles/vars';
.zg-btn {
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
  user-select: none;
  border-radius: 1px;
  font-size: 14px;
  display: inline-block;
  margin-right: 5px;
  .el-icon-warning-outline {
    color: #cd974c;
    margin-left: 5px;
  }
  &&-main {
    border: 1px solid @color-red;
    background-color: @color-red;
    color: #fff;
    &:hover {
      border: 1px solid @color-primary-light;
      background-color: @color-primary-light;
    }
  }
  &&-plain {
    border: 1px solid @color-red;
    background-color: #fff;
    color: @color-red;
    &:hover {
      border: 1px solid @color-primary-light;
      color: @color-primary-light;
    }
  }
  &&-default {
    background-color: #fff;
    border: 1px solid @color-f0;
    color: @color-red;
    &:hover {
      border: 1px solid @color-c;
      color: @color-primary-light;
    }
  }
  &&-base {
    border: 1px solid #f8f8f8;
    background-color: #f8f8f8;
    color: #cd974c;
  }
  &&-text {
    &:hover {
      color: @color-red;
    }
    &--main {
      color: @color-red;
      &:hover {
        color: @color-primary-light;
      }
    }
  }
  &&-weak {
    border: 1px solid @color-f0;
    background: rgba(252, 252, 252, 1);
    color: @color-6;
    &:hover {
      border: 1px solid #dcdcdc;
    }
  }
  &&-gradient {
    background: linear-gradient(90deg, #f0242e, @color-red);
    color: #fff;
    &:hover {
      background: @color-primary-light;
    }
  }
  &&-disable {
    border: 1px solid #ccc;
    background-color: #ccc;
  }
  &:hover {
    cursor: pointer;
  }
}
</style>
